export const SHOW_PRIVACY_MODAL_QUERY_PARAM = "show_privacy_modal";
export const SHOW_TERMS_OF_SALE_MODAL_QUERY_PARAM = "show_terms_of_sale_modal";
export const SHOW_COOKIE_PREFERENCES_MODAL_QUERY_PARAM =
  "show_cookie_preferences_modal";

export const BIMMO_CONTACT_PHONENUMBER = "01\xa078\xa096\xa010\xa000";
